import { BatteryDto } from '@flyfreely-portal-ui/flyfreely';

/**
 * Sort by name, and if names are the same then make, then model.
 * @param a
 * @param b
 */
export function compareBatteries(a: BatteryDto, b: BatteryDto) {
    // Sort primarily by name
    if (a.name !== b.name) {
        return a.name.localeCompare(b.name);
    }
    // If names are the same, sort by make and then by model
    if (a.batteryTypeMake === b.batteryTypeMake) {
        if (a.batteryTypeModel > b.batteryTypeModel) {
            return 1;
        } else {
            return -1;
        }
    } else if (a.batteryTypeMake > b.batteryTypeMake) {
        return 1;
    } else {
        return -1;
    }
}
